import { useThemeStore } from "@stores/theme.store";
import { useEffect, useState } from "react";
import { Button, Form, Input, message } from "antd";
import { BiLogoWhatsapp, BiUser } from "react-icons/bi";
import { TbNumber123 } from "react-icons/tb";
import { useMutation, useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import MaleLogo from "@assets/images/avatar.png";
import FemaleLogo from "@assets/images/avatar-female.png";
import { Spiner } from "@components/loaders/spiner";
import { NoticeType } from "antd/es/message/interface";

export const SettingUpdateAccountPage = () => {
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";
  const gender = dataNis?.data?.gender ?? "";

  const { data, isPending, refetch } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIOGRAPHY, nis],
    queryFn: () => SchoolService.studentBiography(nis),
  });

  const { mutate: onUpdateBio, isPending: isPendingUpdateBio } = useMutation({
    mutationFn: SchoolService.updateStudentBiography,
    onSuccess: (response) => {
      setShowMessage(true);
      setMessageType("success");
      setShowMessageText(response.message);

      refetch();
    },
    onError: (error: any) => {
      setShowMessage(true);
      setMessageType("error");
      setShowMessageText(error.message ?? "Internal Error");
    },
  });

  useEffect(() => {
    setAppBar({ title: "Edit Profil", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      title: "Edit Profil",
      filter: false,
      image: false,
    });
  }, [setHeader, setAppBar]);

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText]);

  return (
    <>
      {contextHolder}
      <div className="tw-px-4 tw-pt-2 tw-pb-0">
        <Form
          className=""
          autoComplete="off"
          initialValues={{
            nis: nis,
            namasiswa: data?.data?.namasiswa ?? "---",
            telephon: data?.data?.telephon ?? "---",
            kelas: data?.data?.kelas ?? "---",
          }}
          onFinish={(data) => onUpdateBio(data)}
        >
          <div className="tw-mb-4 tw-mt-12 tw-pt-14 tw-relative tw-text-center card-body">
            <div className="tw-p-2 tw-rounded-full tw-text-center tw-mb-4 tw-absolute tw-top-0 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2">
              <img
                src={
                  isPending
                    ? MaleLogo
                    : data?.data?.foto === null || data?.data?.foto === ""
                    ? gender === "Pria" || gender === "PRIA" || gender === ""
                      ? MaleLogo
                      : FemaleLogo
                    : `https://sip2.darululumkalbar.com//assets/fotosiswa/${data?.data?.foto}`
                }
                alt=""
                className="tw-w-24 tw-h-24 tw-object-cover tw-rounded-full tw-aling-middle tw-border-[5px] tw-border-solid tw-border-primary tw-bg-gray-100"
              />
            </div>

            <div className="tw-text-lg tw-font-medium tw-text-text-primary">
              {data?.data?.namasiswa ?? "---"}
            </div>

            <div className="tw-text-xs tw-text-text-secondary">
              Kelas {data?.data?.kelas}
            </div>

            <div className="tw-text-xs tw-text-text-secondary">
              Marhalah {data?.data?.marhalah}
            </div>

            <div className="tw-my-4 divider"></div>

            <div className="tw-mb-6 tw-text-accent-primary">
              {isPending ? (
                <div className="tw-p-8 tw-text-center">
                  <Spiner />
                </div>
              ) : (
                <>
                  <Form.Item label="NIS" name="nis" className="tw-mb-4">
                    <Input
                      suffix={
                        <TbNumber123
                          size={20}
                          className="tw-text-text-primary"
                        />
                      }
                      className="tw-border-background tw-shadow-none hover:tw-border-primary focus:tw-shadow-none tw-text-base"
                      placeholder="NIS"
                      disabled={true}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Nama Lengkap"
                    name="namasiswa"
                    className="tw-mb-4"
                  >
                    <Input
                      suffix={
                        <BiUser size={20} className="tw-text-text-primary" />
                      }
                      className="tw-border-background tw-shadow-none hover:tw-border-primary focus:tw-shadow-none tw-text-base"
                      placeholder="Nama Lengkap"
                    />
                  </Form.Item>

                  <Form.Item
                    label="No. Telepon"
                    name="telephon"
                    className="tw-mb-4"
                  >
                    <Input
                      suffix={
                        <BiLogoWhatsapp
                          size={20}
                          className="tw-text-[#91C60B]"
                        />
                      }
                      className="tw-border-background tw-shadow-none hover:tw-border-primary focus:tw-shadow-none tw-text-base"
                      placeholder="-----"
                    />
                  </Form.Item>
                </>
              )}
            </div>
          </div>

          <Button
            type="primary"
            htmlType="submit"
            loading={isPendingUpdateBio}
            className="tw-h-10 tw-w-full tw-text-base tw-rounded-xl bg-gradient tw-shadow-md focus:tw-shadow-none hover:tw-bg-white hover:tw-text-accent-primary hover:tw-border-primary"
          >
            Simpan
          </Button>
        </Form>
      </div>
    </>
  );
};
